import { produce } from "immer";

/**
 * helper for updating apiRequest response to state.
 * returns a setState result
 * @param json response - the response that needs to be updated in state
 * @param {Function} setState - the setState function you receive from useState
 */
export function responseUpdater(response, setState, state) {
  const updateState = updater(setState);
  updateState((draft) => {
    Object.keys(response.data).map((key) => {
      //lowering the first letter, for keeping conventions
      const tempKey = key.replace(/^\w/, (c) => c.toLowerCase());
      return (draft[tempKey] = response.data[key]);
    });
  });
}
/**
 * returns a setState with immer produce integrated
 * @param {Function} setState - the setState function you receive from useState
 */
export function updater(setState) {
  return (func) => setState(produce(func));
}
